import React, {useEffect, useMemo, useState} from 'react';
import {Col, Row} from 'reactstrap';
import {AvForm, AvRadio, AvRadioGroup} from 'availity-reactstrap-validation';
import {StepComponentProps} from '../followup-modal';
import {IPatientBaby} from 'app/shared/model/patient-baby.model';
import FollowupButtons from '../followup-buttons';
import '../followup.scss';

interface BabyFollowupConditionsStepProps extends StepComponentProps {
  updateCurrentBaby?: (updates: Partial<IPatientBaby>) => void;
  currentBabyIndex?: number;
}

const BabyFollowupConditionsStep: React.FC<BabyFollowupConditionsStepProps> = ({
                                                                                 formData,
                                                                                 updateFormData,
                                                                                 onNext,
                                                                                 onPrevious,
                                                                                 canGoBack,
                                                                                 canGoNext,
                                                                                 patientCaseType,
                                                                                 journey,
                                                                                 babyFollowupData,
                                                                                 babyConditionsData,
                                                                                 updateCurrentBaby,
                                                                                 currentBabyIndex = 0,
                                                                               }) => {
  const currentBaby = formData.patientBabies?.[currentBabyIndex];
  const [selectedCondition, setSelectedCondition] = useState<string | null>(currentBaby?.conditionId || null);

  const patientCountryId = journey.patientCase?.patient?.countryId;

  // Filter conditions for baby - use real conditions data
  const babyFollowupConditions = useMemo(() => {
    const hasChildConditions = babyConditionsData?.filter(condition => {
      return (condition.parentId === currentBaby?.outcomeId)
    }).length > 0;

    return babyConditionsData?.filter(condition => {
      const baseConditions = (
        condition.isAlive === currentBaby?.isAlive
      );

      // if the selected outcome has more than one child condition, then filter on the basis of that as well
      if (hasChildConditions) {
        return baseConditions && condition.parentId === currentBaby?.outcomeId;
      }

      return baseConditions;
    }) || [];
  }, [babyConditionsData, currentBaby?.isAlive, currentBaby?.outcomeId]);

  const displayConditions = babyFollowupConditions.length > 0 ? babyFollowupConditions : [];

  useEffect(() => {
    if (updateCurrentBaby) {
      updateCurrentBaby({conditionId: selectedCondition});
    }
  }, [selectedCondition]);

  const handleConditionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedCondition(e.target.value);
  };

  const handleSubmit = (event: any, values: any) => {
    onNext();
  };

  return (
    <div className="followup-step-container">
      <div className="followup-step-content">
        <h6 className="text-primary mb-4">
          Select Baby{currentBabyIndex > 0 ? `#${currentBabyIndex + 1}` : ''} <span className="text-danger">follow-up condition</span>
        </h6>
        <AvForm onValidSubmit={handleSubmit}>
          <AvRadioGroup
            name="babyFollowupCondition"
            required={displayConditions.length > 0}
            value={selectedCondition}
            className="form-control"
            style={{overflowY: 'auto', height: '400px'}}
          >
            <Row>
              {displayConditions.length === 0 ? (
                <Col md="12">
                  <div className="text-center py-4">
                    <div className="text-muted">No conditions available for this patient status.</div>
                  </div>
                </Col>
              ) : (
                displayConditions.map((condition) => (
                  <Col md="12" key={condition.id}>
                    <AvRadio
                      name="babyFollowupCondition"
                      value={condition.id}
                      onChange={handleConditionChange}
                      label={condition.enFollowup}
                    />
                  </Col>
                ))
              )}
            </Row>
          </AvRadioGroup>

          <FollowupButtons
            currentStep={10}
            totalSteps={13}
            canGoBack={canGoBack}
            onPrevious={onPrevious}
          />
        </AvForm>
      </div>
    </div>
  );
};

export default BabyFollowupConditionsStep;
